module.exports = __webpack_public_path__ + "static/media/mask.9d8bbc67.svg";